module.exports = __webpack_public_path__ + "static/media/VU.df68a109.svg";